import React, { useContext } from "react";

import { CameraList } from "../CameraList/CameraList";

import CameraFilterContext from "../CameraFilterContext";
import { useDynamicPager } from "../../../../lib/hooks/useDynamicPager";
import * as styles from "../StaticCameraList/staticCameraList.module.less";

export function DynamicCameraList({ sectionId, itemsPerPage, currency }) {
    const { items } = useContext(CameraFilterContext);

    const { pagedItems, Component: DynamicPager } = useDynamicPager({
        items,
        itemsPerPage: itemsPerPage,
        elementToScroll: sectionId
    });

    return (
        <>
            <CameraList items={pagedItems} currency={currency} />
            <div className={styles.cameraListingPager}>
                <DynamicPager />
            </div>
        </>
    );
}
